module.exports = __webpack_public_path__ + "img/huozai.e883481f.svg";